import React from 'react';
import { LeafIcon, HomeIcon, GiftIcon, StoreIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { forYouItems } from '../data/forYou';
const icons = {
  leaf: LeafIcon,
  home: HomeIcon,
  gift: GiftIcon,
  store: StoreIcon
};
export function ForYou() {
  return;
}